import { TextField, TextFieldProps } from '@mui/material'
import SVG from '../../assets/svg'
import { useState } from 'react'
import { FieldContainer } from '../functional'
import useCheckAutoFill from '../../hooks/useCheckAutoFill'

type PasswordProps = TextFieldProps & {
   name: string
   isNewPassword?: boolean
   highlight?: boolean
}

const Password: React.FC<PasswordProps> = ({ name, label, type, highlight, ...props }) => {
   const [showPassword, setShowPassword] = useState<boolean>(false)
   const { onAnimationStart, hasAutoFill } = useCheckAutoFill()
   return (
      <FieldContainer name={name} highlight={highlight}>
         {(fieldProps) => (
            <div style={{ position: 'relative', fontSize: 16 }}>
               <TextField
                  {...fieldProps}
                  {...props}
                  type={showPassword ? 'text' : 'password'}
                  label={label ?? 'Password'}
                  disabled={props.disabled || fieldProps.disabled}
                  size="medium"
                  InputLabelProps={{ shrink: !!fieldProps.value || hasAutoFill }}
                  inputProps={{
                     onAnimationStart,
                     autoComplete: props.isNewPassword ? 'new-password' : undefined,
                  }}
                  fullWidth
               />
               <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                     cursor: 'pointer',
                     position: 'absolute',
                     padding: '1.1em 1.7em',
                     right: '0%',
                     top: '0.3em',
                  }}
                  className="show-password"
               >
                  {showPassword ? <SVG.form.eyeOpen /> : <SVG.form.eyeClosed />}
               </span>
            </div>
         )}
      </FieldContainer>
   )
}

export default Password
